// @flow
import RadioSelect from 'fg-frontend/src/components/RadioSelect';
import Form from 'fg-frontend/src/components/Form';
import SocialShare from 'fg-frontend/components/SocialShare';
import GtmHandler from './components/GtmHandler';
import TriggerInViewport from './components/TriggerInViewport';
import LazyImage from './components/LazyImage';
// COMMON: Komponenta pro AJAX nacteni SVG spritu
import AddSvgIconSprite from './components/AddSvgIconSprite';

import ParallaxComponent from './components/ParallaxComponent/ParallaxComponent';
import MenuComponent from './components/MenuComponent/MenuComponent';
import BackToTopComponent from './components/BackToTopComponent/BackToTopComponent';
import AccordionComponent from './components/AccordionComponent/AccordionComponent';
import ScrollToAnchorComponent from './components/ScrollToAnchorComponent/ScrollToAnchorComponent';
import ModalComponent from './components/ModalComponent/ModalComponent';
import PhotoSwipe from './components/PhotoSwipe';
import TimelineByWorkflowTinySlider from './components/TinySliders/TimelineByWorkflowTinySlider';
import TimelineByYearTinySlider from './components/TinySliders/TimelineByYearTinySlider';
import ShowBlockOnHoverComponent from './components/ShowBlockOnHoverComponent/ShowBlockOnHoverComponent';
import RefTinySlider from './components/TinySliders/RefTinySlider';
import SubScrollTinySlider from './components/TinySliders/SubScrollTinySlider';
import IntroTinySlider from './components/TinySliders/IntroTinySlider';
import IconTinySlider from './components/TinySliders/IconTinySlider';
import AccordionGalleryTinySlider from './components/TinySliders/AccordionGalleryTinySlider';
import HpTinySlider from './components/TinySliders/HpTinySlider';
import CVPositionComponent from './components/CVPositionComponent/CVPositionComponent';
import DynamicLoadedContentComponent from './components/DynamicLoadedContentComponent/DynamicLoadedContentComponent';


export default (props) => {
  switch (props.decorator || props.is) {
    case 'RadioSelect':
    case 'CheckboxSelect':
      return RadioSelect;
    case 'SocialShare':
      return SocialShare;
    case 'GtmHandler':
      return GtmHandler;
    case 'TriggerInViewport':
      return TriggerInViewport;
    case 'Form':
      return Form;
    case 'LazyImage':
      return LazyImage;
    case 'ParallaxComponent':
      return ParallaxComponent;
    case 'MenuComponent':
      return MenuComponent;
    case 'BackToTopComponent':
      return BackToTopComponent;
    case 'AccordionComponent':
      return AccordionComponent;
    case 'ScrollToAnchorComponent':
      return ScrollToAnchorComponent;
    case 'ModalComponent':
      return ModalComponent;
    case 'PhotoSwipe':
      return PhotoSwipe;
    case 'AddSvgIconSprite':
      return AddSvgIconSprite;
    case 'TimelineByWorkflowTinySlider':
      return TimelineByWorkflowTinySlider;
    case 'TimelineByYearTinySlider':
      return TimelineByYearTinySlider;
    case 'ShowBlockOnHoverComponent':
      return ShowBlockOnHoverComponent;
    case 'HpTinySlider':
      return HpTinySlider;
    case 'RefTinySlider':
      return RefTinySlider;
    case 'IntroTinySlider':
      return IntroTinySlider;
    case 'IconTinySlider':
      return IconTinySlider;
    case 'SubScrollTinySlider':
      return SubScrollTinySlider;
    case 'AccordionGalleryTinySlider':
      return AccordionGalleryTinySlider;
    case 'CVPositionComponent':
      return CVPositionComponent;
    case 'DynamicLoadedContentComponent':
      return DynamicLoadedContentComponent;
    case 'GoogleRecaptcha':
      return import('fg-frontend/src/components/GoogleRecaptcha');
    default:
      console.log(`Unknown component ${props.decorator || props.is}`);
      return null;
  }
};



// WEBPACK FOOTER //
// ./fe/web-career/src/js/configureWebComponents.js